import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-gpus-4",
  "use": "icon-gpus-4-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"icon-gpus-4\">\n  <g id=\"icon-gpus-4_组_6371\" data-name=\"组 6371\" transform=\"translate(-649 -407)\">\n    <g id=\"icon-gpus-4_矩形_3042\" data-name=\"矩形 3042\" transform=\"translate(649 407)\" fill=\"#3a1d27\" stroke=\"#fa5252\" stroke-width=\"1\">\n      <rect width=\"16\" height=\"16\" rx=\"2\" stroke=\"none\" />\n      <rect x=\"0.5\" y=\"0.5\" width=\"15\" height=\"15\" rx=\"1.5\" fill=\"none\" />\n    </g>\n    <path id=\"icon-gpus-4_路径_9557\" data-name=\"路径 9557\" d=\"M.533-4.359A6.752,6.752,0,0,1,1.33-8,2.582,2.582,0,0,1,3.639-9.229q2.883,0,2.883,4.652A6.326,6.326,0,0,1,5.71-1.063,2.585,2.585,0,0,1,3.434.152,2.419,2.419,0,0,1,1.292-1,6.13,6.13,0,0,1,.533-4.359Zm1.172-.053Q1.705-.8,3.539-.8q1.8,0,1.8-3.674,0-3.8-1.77-3.8Q1.705-8.273,1.705-4.412Z\" transform=\"translate(653.467 419.229)\" fill=\"#fa5252\" />\n  </g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/gpus-4.svg
// module id = E1qz
// module chunks = 103